import { defineStore } from 'pinia';
import { NotificationInterface, NotificationTypes } from '@/types';
import { ref } from 'vue';

export const useNotificationsStore = defineStore('notifications', () => {
  const notifications = ref<NotificationInterface[]>([]);

  const showNotification = (notification:string, type:NotificationTypes, time:number = 5000):void => {
    const timestamp:number = Date.now();
    const hash = hashCode(notification);

    setTimeout(() => {
      const notoficationToDelete = notifications.value.findIndex(notification => notification.timestamp === timestamp);

      if (notoficationToDelete > -1) {
        deleteNotification(notoficationToDelete);
      }
    }, time);

    if (!notifications.value.some((notification:NotificationInterface) => notification.hash === hash)) {
      notifications.value.push({ notification, type, hash, timestamp });
    }

  };

  const hashCode = (s:string):number => {
    return s.split("").reduce(function(a,b){a=((a<<5)-a)+b.charCodeAt(0);return a&a},0);
  };

  const deleteNotification = (index:number):void => {
    notifications.value.splice(index, 1);
  };

  const error = (notification:string):void => {
    showNotification(notification, NotificationTypes.Error);
  };

  const success = (notification:string):void => {
    showNotification(notification, NotificationTypes.Success);
  };
  
  return { notifications, showNotification, error, success, deleteNotification };
});